import { render, staticRenderFns } from "./DetailArticle.vue?vue&type=template&id=87675ec6"
import script from "./DetailArticle.vue?vue&type=script&lang=js"
export * from "./DetailArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports